import { get } from 'lodash'

export default (values, validation) => {
  const hasFormValidation = (validation, get) => (field, property) =>
    get(validation, ['fields', field, '_exclusive', property])
  values.__methods = {
    __hasValidation: (field, property) => hasFormValidation(validation, get)(field, property)
  }
}
